export default {
	SERVER_URL: "https://admin.matchdaydigital.com",
	ONESIGNAL_APP_ID: "d96ac253-4729-4169-af6c-1d88e8dc9681",
	STRIPE_KEY: "pk_live_51GuKqgHg9TdUEpMOlZQv1fz7nTlcr62a2NFrurDGCLFQgxBWLSS6CxwptFigV6c2dZDAlhtFF7SpfQarNDeUrt3S00oArwrb3W",
}